import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {RolesActions} from "../actions";
import {catchError, map, mergeMap} from "rxjs";
import {ApiError, RolesService} from "@esa/api";
import {ApiErrorHandlerService} from "../../services";

@Injectable()
export class RolesEffects {

  getRoles$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RolesActions.getRoles),
      mergeMap(({}) => this._rolesService.getApiRole().pipe(
        map(response => RolesActions.getRolesSuccess({ roles: response.data })),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, RolesActions.getRolesError());
        })
      ))
    );
  });

  constructor(
    private actions$: Actions,
    private _rolesService: RolesService,
    private apiErrorHandlerService: ApiErrorHandlerService
  ) {}
}
